<template>
  <h2
    class="text-center sm:text-left font-bold leading-[1.3] lg:pr-20 max-xl:px-4 max-md:px-0"
  >
    <WrGradientText
      :text="heading"
      append-class="pb-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,var(--text-gradient-1)-1.57%,_var(--text-gradient-2)_30.72%)]"
    />
  </h2>
  <div
    class="flex mt-10 md:my-20 items-start justify-between lg:flex-row flex-col max-xl:gap-10"
  >
    <div class="flex flex-col items-start xl:max-w-[40%] w-full">
      <p class="leading-[1.7] max-md:text-center md:text-lg break-words dark:text-white">
        {{ subheading }}
      </p>
      <ul class="mt-5 ">
        <li
          v-for="item in expertisetext"
          class="block text-[1.02rem] pl-[30px] pb-[10px] bg-[url('/images/tick-v1.webp')] bg-no-repeat bg-[position:0_2px]"
        >
          {{ item.heading }}
        </li>
        <li
          v-for="item in textcontent"
          class="dark:text-white block text-[1.02rem] pl-[30px] pb-[10px] bg-[url('/images/tick-v1.webp')] bg-no-repeat bg-[position:0_2px]"
        >
          {{ item.heading }}
        </li>
      </ul>
    </div>
    <div
      class="relative before:max-lg:hidden z-10 flex flex-col items-start gap-4 before:content-[''] before:absolute before:top-[0px] before:right-[110px] before:w-[250px] before:h-[500px] before:bg-[#cacfdd] dark:before:bg-[#261640] before:rounded-tr-[490px] before:rounded-br-[490px] before:rotate-[23deg] max-xl:w-full"
    >
      <template v-for="card in keywords">
        <div
          class="relative z-10 p-5 shadow-[0_0_0.9375rem_0.125rem_rgba(35,66,104,0.15)] dark:bg-[rgba(98,69,116,1)] bg-white w-full md:min-w-[467px] rounded-xl max-xl:w-full"
        >
          <h3 class="text-sm font-semibold">{{ card.title }}</h3>
          <p>{{ card.subtitle }}</p>
        </div>
      </template>
    </div>
  </div>

  <p
    v-if="text != ''"
    class="text-xs z-20 !mt-10 md:!mt-30 dark:bg-[#261640] py-4 md:py-6 sm:text-lg pl-7 mx-auto border-l-2 border-[#5f4ca4] dark:border-white text-[#5f4ca4] dark:text-white lg:pr-0 max-md:pr-0"
  >
    {{ text }}
  </p>
</template>

<script setup>
const WrGradientText = defineAsyncComponent(() => import('~/components/global/WrGradientText.vue'))
defineProps({
  heading: String,
  subheading: String,
  expertisetext: Array,
  textcontent: Array,
  text: String,
  keywords: Array,
});
</script>

<style lang="scss" scoped></style>
